import { render, staticRenderFns } from "./PackageContentFamily.vue?vue&type=template&id=23c2dfca&scoped=true&"
import script from "./PackageContentFamily.vue?vue&type=script&lang=ts&"
export * from "./PackageContentFamily.vue?vue&type=script&lang=ts&"
import style0 from "./PackageContentFamily.vue?vue&type=style&index=0&id=23c2dfca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2dfca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VImg,VRow,VSpacer})
